<template>
  <div class="card-body">
    <form id="cartaoForm">
      <div class="form-group">
        <label for="numeroCartao">
          Número do Cartão
        </label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="numeroCartao"
            placeholder="1234 5678 9012 3456"
            v-model="cartao.numeroCartao"
            v-mask="'#### #### #### ####'"
            required
          />
          <div class="input-group-append">
            <span class="input-group-text">
              <i class="far fa-credit-card"></i>
            </span>
          </div>
        </div>
        <small class="form-text text-muted"> Digite os 16 dígitos do seu cartão </small>
      </div>

      <div class="form-group">
        <label for="nomeTitular">
          Nome do Titular
        </label>
        <input
          type="text"
          class="form-control"
          id="nomeTitular"
          placeholder="Como está escrito no cartão"
          v-model="cartao.nomeTitular"
          required
        />
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="dataValidade">
              Data de Validade
            </label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                id="dataValidade"
                placeholder="MM/AA"
                v-model="cartao.dataValidade"
                v-mask="'##/##'"
                required
              />
              <div class="input-group-append">
                <span class="input-group-text">
                  <i class="far fa-calendar-check"></i>
                </span>
              </div>
            </div>
            <small class="form-text text-muted"> Mês/Ano (ex: 12/24) </small>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label for="cvv">
              CVV
            </label>
            <div class="input-group">
              <input
                type="password"
                class="form-control"
                id="cvv"
                placeholder="123"
                v-model="cartao.cvv"
                v-mask="['###', '####']"
                required
              />
              <div class="input-group-append">
                <span class="input-group-text">
                  <i class="fas fa-shield-alt"></i>
                </span>
              </div>
            </div>
            <small class="form-text text-muted">
              3 ou 4 dígitos na parte de trás do cartão
            </small>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="parcelas">
          Parcelas
        </label>
        <div class="input-group mb-3">
          <select class="custom-select" id="inputGroupSelect00" v-model="cartao.parcelas">
            <!-- <option value="DEBITO">Débito</option> -->
            <option value="1">1 parcela</option>
            <option value="2">2 parcela</option>
            <option value="3">3 parcela</option>
            <option value="4">4 parcela</option>
            <option value="5">5 parcela</option>
            <option value="6">6 parcela</option>
            <option value="7">7 parcela</option>
            <option value="8">8 parcela</option>
            <option value="9">9 parcela</option>
            <option value="10">10 parcela</option>
            <option value="11">11 parcela</option>
            <option value="12">12 parcela</option>
          </select>
        </div>
      </div>

      <div class="d-flex flex-row w-100">
        <div class="form-group w-50">
          <label for="tipoCartao">
            Tipo de Cartão
          </label>
          <div class="input-group mb-3">
            <select
              class="custom-select"
              id="inputGroupSelect01"
              v-model="cartao.tipoCartao"
            >
              <option value="debit">Débito</option>
              <option value="credit">Crédito</option>
            </select>
          </div>
        </div>
        <div class="form-group w-50">
          <label for="tipoCartao">
            Bandeira
          </label>
          <div class="input-group mb-3">
            <select
              class="custom-select"
              id="inputGroupSelect01"
              v-model="cartao.bandeira"
            >
              <option value="American Express">American Express</option>
              <option value="MasterCard">MasterCard</option>
              <option value="Visa">Visa</option>
              <option value="Aura">Aura</option>
              <option value="Banescard">Banescard</option>
              <option value="Cabal">Cabal</option>
              <option value="Diners Club">Diners Club</option>
              <option value="Discover">Discover</option>
              <option value="Elo">Elo</option>
              <option value="Hipercard">Hipercard</option>
              <option value="Hiper">Hiper</option>
              <option value="JCB">JCB</option>
            </select>
          </div>
        </div>
      </div>

      <button
        type="button"
        class="btn btn-primary"
        style="float: right"
        @click="emitirDadosCartao()"
      >
        Enviar
      </button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cartao: {
        numeroCartao: "",
        nomeTitular: "",
        dataValidade: "",
        cvv: "",
        tipoCartao: "credit",
        bandeira: "Visa",
        parcelas: 1,
      },
    };
  },

  methods: {
    emitirDadosCartao() {
      this.$emit("update-cartao", this.cartao);
    },
  },
};
</script>
